import React, { useState, useEffect } from "react";
import "./../App.css";
import "./pagination.css";

import 'bootstrap/dist/css/bootstrap.min.css';
import Services from './Services'
import { hospitalcodedata } from './hospitalcodedata';

import { Table } from "react-bootstrap";
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'reactjs-popup/dist/index.css';
import Pagination from "rc-pagination";
import 'rc-pagination/assets/index.css'; // Required default styles

import { ExportToExcel } from './ExcelExportfile'
import { ExportToNestedExcel } from './ExportToNestedExcel'
import { ExportToWord } from './ExportToWord'
import { ExportExcel } from './ExportExcel'

import Form from 'react-bootstrap/Form'
import { RotatingLines } from "react-loader-spinner";

const moment = require("moment");

const Patientsdata = () => {

    const [loading, setLoading] = useState(false);

    var today = moment(new Date(), "DD/MM/YYYY").toDate();
    var priorDate = new Date(new Date(today).setDate(today.getDate() - 30));

    const [hospitalfilterdata, setHospitalfilterdata] = useState({
        hospital_type: "",
        hospital_code: "",
    });

    const [filteredData, setFilteredData] = useState({
        f_fromdate: priorDate.toISOString().slice(0, 10),
        f_todate: today.toISOString().slice(0, 10)
    });

    function handleChange(event, from) {
        const { name, value } = event.target;
        setFilteredData({ ...filteredData, [name]: value });
    }

    const [patients, setPatients] = useState([]);
    const [filteredList, setFilteredList] = useState(patients);

    const [totalExceldata, setTotalExceldata] = useState([]);
    const [patientExceldata, setPatientExceldata] = useState([]);
    const [monthlypatientExceldata, setMonthlypatientExceldata] = useState([]);

    const [hospitaltype, sethospitaltype] = useState([]);
    const [hospitalcode, sethospitalcode] = useState([]);

    useEffect(() => {
        try {

            const hospitaltype = [{ hospitaltype_name: "DME" }, { hospitaltype_name: "VVP" }];
            sethospitaltype(hospitaltype);

            const filtered = hospitalcodedata.filter(hospitalcodedata => {
                return hospitalcodedata.hospitaltype_name === hospitalfilterdata.hospital_type;
            });

            sethospitalcode(filtered);
        } catch (e) {
            console.log(e);
        }
    }, [hospitalfilterdata.hospital_type]);

    function handleChangeHospitaltypes(event, frm) {

        if (frm === "hspttype") {
            hospitalfilterdata.hospital_code = "";
        }
        const { name, value } = event.target;
        setHospitalfilterdata({ ...hospitalfilterdata, [name]: value });
    }

    const validateForm = (e) => {

        let formIsValid = true;

        if (!hospitalfilterdata.hospital_type?.trim()) {
            alert("Select Hospital Type");
            formIsValid = false;
        } else if (!hospitalfilterdata.hospital_code?.trim()) {
            alert("Select Hospital Code");
            formIsValid = false;
        }

        return formIsValid;
    }

    const getlistdata = () => {
        setPatients([]);
        setFilteredList([]);
        setPatientExceldata([]);
        setTotalExceldata([]);
        setMonthlypatientExceldata([]);

        if (validateForm()) {

            setPatients([]);
            setFilteredList([]);
            setPatientExceldata([]);
            setTotalExceldata([]);
            setMonthlypatientExceldata([]);

            if (filteredData.f_fromdate === "") {
                alert("Please select from date.");
            } else {
                if (filteredData.f_todate === "") {
                    alert("Please select to date.");
                } else {
                    if (filteredData.f_fromdate > filteredData.f_todate) {
                        alert("'From date' must be less than or equals to 'To date'");
                    } else {
                        setLoading(true);

                        let filterquary1 = {
                            list_type: "Last30days",
                            hospital_type: hospitalfilterdata.hospital_type,
                            hospital_code: hospitalfilterdata.hospital_code,
                            f_fromdate: moment(filteredData.f_fromdate).format("DD-MM-YYYY"),
                            f_todate: moment(filteredData.f_todate).format("DD-MM-YYYY")
                        };

                        Services.getPatientlistdata(filterquary1).then((res) => {
                            if (res.status === 200) {

                                const patients = res.data.patients;

                                if (patients.length === 0) {
                                    alert("Empty Data")
                                }

                                const patientsarray = patients.slice().reverse();
                                setPatients(patientsarray);
                                setFilteredList(patientsarray);
                                GetExceldata(patientsarray);
                                setLoading(false);

                            } else Promise.reject();
                        }).catch((error) => {
                            alert("Something went wrong(" + error + ")");
                            setLoading(false);

                        });

                    }
                }
            }

        }
    }

    const GetExceldata = (exdata) => {

        const exceldatalist1 = [];
        const exceldatalist2 = [];
        const exceldatalist3 = [];

        for (let i = 0; i < exdata.length; i++) {
            let sno = i + 1;

            let child_data = "";

            if (exdata[i].patient_infant_status === "IUD") {
                child_data = "Child 1 : IUD";
            } else {
                const charray = exdata[i].patient_child_tagids || [];

                child_data = charray
                    .map((child, idx) => {
                        const status = child.child_status;
                        const tagId = child.child_tagId;
                        const gender = child.child_gender;

                        return status === "IUD"
                            ? `Child ${idx + 1} : IUD`
                            : `${tagId}-${gender}`;
                    })
                    .join(", ");
            }



            const data = {
                sno: sno,
                key: exdata[i].key,
                hospital_type: exdata[i].hospital_type,
                hospital_code: exdata[i].hospital_code,
                patient_id: exdata[i].patient_id,
                patient_registration_type: exdata[i].patient_registration_type,
                patient_outbound_entry_type: exdata[i].patient_outbound_entry_type,
                patient_aadhar: exdata[i].patient_aadhar,
                patient_rchid: exdata[i].patient_rchid,
                patient_ipnumber: exdata[i].patient_ipnumber,
                patient_name: exdata[i].patient_name,
                patient_guardian_name: exdata[i].patient_guardian_name,
                patient_gender: exdata[i].patient_gender,
                patient_mobileno: exdata[i].patient_mobileno,
                patient_alternative_mobileno: exdata[i].patient_alternative_mobileno,
                patient_dob: exdata[i].patient_dob,
                patient_address: exdata[i].patient_address,
                patient_city: exdata[i].patient_city,
                patient_blood_group: exdata[i].patient_blood_group,
                patient_infant_status: exdata[i].patient_infant_status,
                patient_infant_count: exdata[i].patient_infant_count,
                patient_mastername: exdata[i].patient_mastername,
                patient_masterid: exdata[i].patient_masterid,
                patient_tagid: exdata[i].patient_tagid,
                child_data: child_data,
                patient_status: exdata[i].patient_status,
                remarks: `${exdata[i].patient_registration_remarks_type} : ${exdata[i].patient_registration_remarks_comments} `,
                acknowledgement_form: exdata[i].patient_registration_acknowledgement_form,

                patient_created_date: exdata[i].patient_created_date,
                patient_updated_date: exdata[i].patient_updated_date,
                patient_discharged_date: exdata[i].patient_discharged_date,
                record_created_month: exdata[i].record_created_month,
                record_created_date: exdata[i].record_created_date
            }

            const data3 = {
                SNo: sno,
                Hospital: exdata[i].hospital_type + " " + exdata[i].hospital_code,
                PatientId: exdata[i].patient_id,
                PatientName: exdata[i].patient_name,
                Mobileno: exdata[i].patient_mobileno,
                Address: exdata[i].patient_address,
                PatientTagid: exdata[i].patient_tagid,
                child_data: child_data,
                Status: exdata[i].patient_status,
                CreatedDate: exdata[i].patient_created_date,
                DischargedDate: exdata[i].patient_discharged_date,
            }

            const data2 = {
                SNo: sno,
                Created_Date: exdata[i].patient_created_date,
                Patient_Registration_Type: exdata[i].patient_registration_type,
                Patient_Aadhar: exdata[i].patient_aadhar,
                Patient_RCHid: exdata[i].patient_rchid,
                Patient_IPnumber: exdata[i].patient_ipnumber,
                PatientName: exdata[i].patient_name,
                Mobileno: exdata[i].patient_mobileno,
                Patient_Infant_Status: exdata[i].patient_infant_status,
                Patient_Infant_Count: exdata[i].patient_infant_count,
                Remarks: `${exdata[i].patient_registration_remarks_type} : ${exdata[i].patient_registration_remarks_comments} `,
                Acknowledgement_form: exdata[i].patient_registration_acknowledgement_form,
            }

            exceldatalist1.push(data);
            exceldatalist2.push(data2);
        }

        const date_log = getDatesDiff(moment(filteredData.f_fromdate).format("DD-MM-YYYY"), moment(filteredData.f_todate).format("DD-MM-YYYY"));

        for (let i = 0; i < date_log.length; i++) {

            const totalbirthscount = [];
            const sncucount = [];
            const nicucount = [];
            const nbsucount = [];
            const totaltagscount = [];
            const IUDcount = [];

            for (let j = 0; j < exdata.length; j++) {

                if (exdata[j].patient_created_date === date_log[i]) {

                    if (exdata[j].patient_tagid !== "") {
                        // totaltagscount.push(exdata[j].patient_tagid);
                    }

                  /*   if (exdata[j].patient_infant_status === "IUD") {
                        IUDcount.push(exdata[j].patient_infant_status);
                    }


                    let charray = exdata[j].patient_child_tagids;
                    for (let k = 0; k < charray.length; k++) {

                        totaltagscount.push(charray[k].child_tagId);

                        if (exdata[j].patient_registration_type === "Out Patient") {

                            if (exdata[j].patient_outbound_entry_type === "SNCU") {
                                sncucount.push(charray[k].child_tagId);

                            } else if (exdata[j].patient_outbound_entry_type === "NICU") {
                                nicucount.push(charray[k].child_tagId);

                            } else if (exdata[j].patient_outbound_entry_type === "NBSU") {
                                nbsucount.push(charray[k].child_tagId);
                            } else {
                                sncucount.push(charray[k].child_tagId);
                            }

                        } else {
                            totalbirthscount.push(charray[k].child_tagId);
                        }


                    }
 */

                    const patient = exdata[j];

                    // Count patient-level IUDs
                    if (patient.patient_infant_status === "IUD") {
                        IUDcount.push(patient.patient_infant_status);
                    }

                    // Process children if any
                    const charray = patient.patient_child_tagids;
                    for (let k = 0; k < charray.length; k++) {
                        const child = charray[k];
                        const { child_status: status, child_tagId: tagId } = child;

                        const isIUD = status === "IUD";

                        // Count total tags (exclude IUDs)
                        if (!isIUD) {
                            totaltagscount.push(tagId);
                        }

                        if (patient.patient_registration_type === "Out Patient") {
                            switch (patient.patient_outbound_entry_type) {
                                case "SNCU":
                                    isIUD ? IUDcount.push(status) : sncucount.push(tagId);
                                    break;
                                case "NICU":
                                    isIUD ? IUDcount.push(status) : nicucount.push(tagId);
                                    break;
                                case "NBSU":
                                    isIUD ? IUDcount.push(status) : nbsucount.push(tagId);
                                    break;
                                default:
                                    isIUD ? IUDcount.push(status) : sncucount.push(tagId);
                            }
                        } else {
                            // In-patient or other types
                            isIUD ? IUDcount.push(status) : totalbirthscount.push(tagId);
                        }
                    }


                }

                if (exdata.length === j + 1) {
                    const data = {
                        hospitalname: hospitalfilterdata.hospital_type + " " + hospitalfilterdata.hospital_code,
                        hospitalcode: hospitalfilterdata.hospital_code,
                        monthname: moment(filteredData.f_fromdate).format("DD-MM-YYYY") + " TO " + moment(filteredData.f_todate).format("DD-MM-YYYY"),
                        date: date_log[i],
                        totalbirths: totalbirthscount.length,
                        sncu: sncucount.length,
                        nicu: nicucount.length,
                        nbsu: nbsucount.length,
                        totaltags: totaltagscount.length,
                        iuddata: IUDcount.length
                    }
                    exceldatalist3.push(data);
                }
            }
        }
        setTotalExceldata(exceldatalist1);
        setPatientExceldata(exceldatalist2);
        setMonthlypatientExceldata(exceldatalist3);
    }

    const getDatesDiff = (start_date, end_date, date_format = "DD-MM-YYYY") => {
        const getDateAsArray = date => {
            return moment(date.split(/\D+/), date_format);
        };
        const diff = getDateAsArray(end_date).diff(getDateAsArray(start_date), "days") + 1;
        const dates = [];
        for (let i = 0; i < diff; i++) {
            const nextDate = getDateAsArray(start_date).add(i, "day");
            const isWeekEndDay = nextDate.isoWeekday() > 7;
            if (!isWeekEndDay)
                dates.push(nextDate.format(date_format))
        }
        return dates;
    };









    const Patientsdata = () => {

        const [filteredPatientList, setFilteredPatientList] = useState(filteredList);

        const [perPage] = useState(15);
        const [size, setSize] = useState(perPage);
        const [current, setCurrent] = useState(1);

        // New: Filter states
        const [typeFilter, setTypeFilter] = useState("ALL");
        const [infantCountFilter, setInfantCountFilter] = useState("ALL");

        // New: Apply merged filters
        const applyFilters = (type = typeFilter, infantCount = infantCountFilter) => {
            let filtered = filteredList;

            if (type !== "ALL") {
                filtered = filtered.filter(item => item.patient_registration_type === type);
            }

            if (infantCount !== "ALL") {
                filtered = filtered.filter(item => item.patient_infant_count === infantCount);
            }

            setFilteredPatientList(filtered);
            setCurrent(1); // reset pagination
        };

        // When dropdown changes
        const handleTypeChange = (value) => {
            setTypeFilter(value);
            setInfantCountFilter("ALL");
            applyFilters(value, "ALL");
        };

        const handleInfantCountChange = (value) => {
            setInfantCountFilter(value);
            applyFilters(typeFilter, value);
        };

        const currentData = (current, pageSize) => {
            return filteredPatientList.slice((current - 1) * pageSize, current * pageSize);
        };

        const PrevNextArrow = (current, type, element) => {
            if (type === "prev") return <button>{"<<"}</button>;
            if (type === "next") return <button>{">>"}</button>;
            return element;
        };

        const handlePaginationChange = (page, pageSize) => {
            setCurrent(page);
            setSize(pageSize);
        };

        return (
            <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                <div style={{ borderTop: "4px solid #dfe3ff ", marginBottom: "10px" }}></div>
                <div className="start_start" style={{ width: "100%", background: "#f7f7f7" }}>
                    <div className="start_start" style={{ width: "50%" }}>
                        <h1 style={{ marginLeft: "10px", fontSize: "14px", color: "black" }}>Patients List</h1>
                    </div>
                    <div className="end_end" style={{ width: "50%" }}>
                        {(() => {
                            if (totalExceldata.length !== 0) {
                                return (<>
                                    Total Data<ExportToExcel apiData={totalExceldata} fileName={"PatientsTotaldata_" + filteredData.f_fromdate + "_TO_" + filteredData.f_todate} />
                                    Patient Data<ExportToExcel apiData={patientExceldata} fileName={"Patientsdata_" + filteredData.f_fromdate + "_TO_" + filteredData.f_todate} />
                                    Month Report<ExportToWord apiData={monthlypatientExceldata} fileName={"MonthlyTagsdata_" + filteredData.f_fromdate + "_TO_" + filteredData.f_todate} />

                                </>
                                )
                            } else {
                                return (
                                    <div />
                                )
                            }
                        })()}
                    </div>
                </div>
                <div style={{ borderTop: "2px solid #dfe3e7 ", marginBottom: "10px" }}></div>


                <Table striped bordered hover style={{ fontSize: "12px" }}>
                    <thead>
                        <tr >
                            <th rowSpan="1" style={{ background: "#b6cceeff", }}>SNo</th>
                            <th rowSpan="1" style={{ background: "#b6cceeff", }}>Delivery date</th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <span style={{ fontWeight: "bold", marginBottom: "5px" }}>Registration type</span>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <select onChange={(e) => handleTypeChange(e.target.value)} style={{ padding: "4px", width: "90px" }} value={typeFilter}>
                                            <option value="ALL">All</option>
                                            <option value="NVD">NVD</option>
                                            <option value="LSCS">LSCS</option>
                                            <option value="Out Patient">OUT BORN</option>
                                        </select>
                                        <ExportExcel apiData={filteredPatientList} fileName={"Patientsdata_" + filteredData.f_fromdate + "_TO_" + filteredData.f_todate} />
                                    </div>
                                </div>
                            </th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>Aadhar</th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>RCH ID</th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>IP number</th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>Patient Name</th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>Mobile no</th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>Infant status</th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <span style={{ fontWeight: "bold", marginBottom: "5px" }}>Infant count</span>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                        <select onChange={(e) => handleInfantCountChange(e.target.value)} style={{ padding: "4px", width: "80px" }} value={infantCountFilter}>
                                            <option value="ALL">All</option>
                                            <option value="1">Single</option>
                                            <option value="2">Twins</option>
                                            <option value="3">Triplets</option>
                                        </select>
                                    </div>
                                </div>
                            </th>
                            <th rowSpan="2" style={{ background: "#b6cceeff", }}>Status</th>

                        </tr>
                    </thead>

                    <tbody>
                        {currentData(current, size).length > 0 ? (
                            currentData(current, size).map((p, index) => (
                                <tr key={index}>
                                    <td>{(current - 1) * perPage + index + 1}</td>
                                    <td>{p.patient_created_date}</td>
                                    <td>{p.patient_registration_type}</td>
                                    <td>{p.patient_aadhar}</td>
                                    <td>{p.patient_rchid}</td>
                                    <td>{p.patient_ipnumber}</td>
                                    <td>{p.patient_name}</td>
                                    <td>{p.patient_mobileno}</td>
                                    <td>{p.patient_infant_status}</td>
                                    <td>{p.patient_infant_count}</td>
                                    <td>
                                        {p.patient_status === "IN HOSPITAL" ? (
                                            <b style={{ color: "green" }}>{p.patient_status}</b>
                                        ) : p.patient_status === "DISCHARGE" ? (
                                            <b style={{ color: "red" }}>{p.patient_status}</b>
                                        ) : null}
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" align="center">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                {/* Pagination */}
                <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
                    <Pagination
                        current={current}
                        total={filteredPatientList.length}
                        pageSize={size}
                        onChange={handlePaginationChange}
                        itemRender={PrevNextArrow}
                        showLessItems={false}
                        showTotal={(total, range) => `Showing ${range[0]} - ${range[1]} of ${total}`}
                        hideOnSinglePage={true}
                    />
                </div>
            </div>
        );
    };

    // Return Agent form
    return (
        <div className="full_frame_center" >
            <div className="start_start" style={{ margin: "20px" }}>
                <div style={{ width: "100%" }}>
                    <div style={{ borderTop: "1px solid #000 ", marginBottom: "10px" }}></div>
                    <div className="start_start" style={{ width: "100%", marginTop: "20px", flexDirection: "column", background: "white" }}>
                        <div className="start_start" style={{ width: "80%", flexDirection: "row", paddingRight: "20px" }}>


                            <div className="start_center" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                <label htmlFor="hospital_type" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>
                                    Hospital Type<b style={{ color: "red" }}>*</b></label>
                                <Form.Select aria-label="Default select example" name="hospital_type" value={hospitalfilterdata.hospital_type}
                                    onChange={(event) => handleChangeHospitaltypes(event, "hspttype")} style={{ fontSize: "12px", width: "100%", padding: "6px" }} >
                                    <option value="">SELECT</option>
                                    {hospitaltype.map((hospitaltype, index) => (
                                        <option key={index} value={hospitaltype.hospitaltype_name}>{hospitaltype.hospitaltype_name}</option>
                                    ))}
                                </Form.Select>

                            </div>

                            <div className="start_center" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                <label htmlFor="hospital_code" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>
                                    Hospital Code<b style={{ color: "red" }}>*</b></label>

                                <Form.Select aria-label="Default select example" name="hospital_code" value={hospitalfilterdata.hospital_code}
                                    onChange={(event) => handleChangeHospitaltypes(event, "")} style={{ fontSize: "12px", width: "100%", padding: "6px" }} >
                                    <option value="">SELECT</option>
                                    {hospitalcode.map((hospitalcode, index) => (
                                        <option key={index} value={hospitalcode.hospitalcode_name}>{hospitalcode.hospitalcode_name}</option>
                                    ))}
                                </Form.Select>

                            </div>


                            <div className="start_center" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                <label htmlFor="f_fromdate" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>From Date</label>
                                <input type="date" name="f_fromdate" value={filteredData.f_fromdate}
                                    style={{ fontSize: "12px", width: "100%", padding: "6px" }} onChange={(event) => handleChange(event, "fromdate")} />
                            </div>

                            <div className="start_center" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                <label htmlFor="f_todate" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>To Date</label>
                                <input type="date" name="f_todate" value={filteredData.f_todate}
                                    style={{ fontSize: "12px", width: "100%", padding: "6px" }} onChange={(event) => handleChange(event, "todate")} />
                            </div>

                            <div className="start_center" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                <label htmlFor="f_todate" className='text-controol' style={{
                                    width: "50%", fontSize: "13px",
                                    color: "green"
                                }}>get</label>
                                <input type="button" style={{
                                    background: "#28a745", borderColor: "#28a745", color: "#ffffff",
                                    fontSize: "12px", width: "50%", padding: "6px"
                                }} onClick={getlistdata} name="f_todate" value="GET" />
                            </div>
                        </div>

                        {loading ? (
                            <div className="center_center" style={{ width: "100%", display: "flex" }}>
                                <RotatingLines width="50px" height="50px" strokeColor="red" strokeWidth="8"
                                    animationDuration="0.75" visible={true} />
                            </div>
                        ) : (
                            <Patientsdata />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// Export Patientsdata Component
export default Patientsdata;